module.exports = __webpack_public_path__ + "media/markers/marker-cluster-orange-de21ebe3.svg";